<template>
  <v-container class="px-0 my-3">
    <v-row>
      <v-col class="v-col-12 v-col-lg-3">
        <div class="w-100 bg-white">
          <v-list class="pa-0 d-none d-lg-block br-top-5">
            <v-list-item prepend-icon="mdi-menu" class="bg-color-2 text-white">Perfil</v-list-item>
            <v-list-item append-icon="mdi-chevron-right" :active="link == 'cadastro' ? true : false" @click="$router.push('/profile/cadastro')" class="link-menu">
              <div class="d-flex align-center">
                <Svgs :icon="'perfil'" :color="'fill-color-2'" :width="30" :height="30"></Svgs> <span class="ms-3">Meu Cadastro</span>
              </div>
            </v-list-item>
            <v-list-item append-icon="mdi-chevron-right" :active="link == 'pedidos' ? true : false" @click="$router.push('/profile/pedidos')" class="link-menu">
              <div class="d-flex align-center">
                <Svgs :icon="'carrinho'" :color="'fill-color-2'" :width="30" :height="30"></Svgs> <span class="ms-3">Meus Pedidos</span>
              </div>
            </v-list-item>
            <v-list-item append-icon="mdi-chevron-right" :active="link == 'enderecos' ? true : false" @click="$router.push('/profile/enderecos')" class="link-menu">
              <div class="d-flex align-center">
                <Svgs :icon="'pin'" :color="'fill-color-2'" :width="30" :height="30"></Svgs> <span class="ms-3">Meus Endereços</span>
              </div>
            </v-list-item>
            <v-list-item append-icon="mdi-chevron-right" :active="link == 'senha' ? true : false" @click="$router.push('/profile/senha')" class="link-menu">
              <div class="d-flex align-center">
                <Svgs :icon="'cadeado'" :color="'fill-color-2'" :width="30" :height="30"></Svgs> <span class="ms-3">Alterar Senha</span>
              </div>
            </v-list-item>
            <v-list-item append-icon="mdi-chevron-right" :active="link == 'excluir' ? true : false" @click="$router.push('/profile/excluir')" class="link-menu">
              <div class="d-flex align-center">
                <Svgs :icon="'excluir'" :color="'fill-color-2'" :width="30" :height="30"></Svgs> <span class="ms-3">Excluir Conta</span>
              </div>
            </v-list-item>
            <v-list-item append-icon="mdi-chevron-right" @click="Logout()" class="link-menu">
              <div class="d-flex align-center">
                <Svgs :icon="'sair'" :color="'fill-color-2'" :width="30" :height="30"></Svgs> <span class="ms-3">Sair</span>
              </div>
            </v-list-item>
          </v-list>
          <div class="d-block d-lg-none px-3">
            <v-menu :location="'top'">
              <template v-slot:activator="{ props }">
                  <v-btn v-bind="props" prepend-icon="mdi-menu" block class="bg-color-2 text-white">Perfil</v-btn>
              </template>
              <v-list class="pa-0">
                <v-list-item append-icon="mdi-chevron-right" :active="link == 'cadastro' ? true : false" @click="$router.push('/profile/cadastro')" class="link-menu">Meu Cadastro</v-list-item>
                <v-list-item append-icon="mdi-chevron-right" :active="link == 'pedidos' ? true : false" @click="$router.push('/profile/pedidos')" class="link-menu">Meus Pedidos</v-list-item>
                <v-list-item append-icon="mdi-chevron-right" :active="link == 'enderecos' ? true : false" @click="$router.push('/profile/enderecos')" class="link-menu">Meus Endereços</v-list-item>
                <v-list-item append-icon="mdi-chevron-right" :active="link == 'senha' ? true : false" @click="$router.push('/profile/senha')" class="link-menu">Alterar Senha</v-list-item>
                <v-list-item append-icon="mdi-chevron-right" :active="link == 'excluir' ? true : false" @click="$router.push('/profile/excluir')" class="link-menu">Excluir Conta</v-list-item>
                <v-list-item append-icon="mdi-chevron-right" @click="Logout()" class="link-menu">Sair</v-list-item>
              </v-list>
            </v-menu>
          </div>
        </div>
      </v-col>
      <v-col class="v-col-12 v-col-lg-9 px-6 px-lg-0" v-if="getConfig.isu == 0">
        <div class="w-100 bg-white pa-5 pb-10 br-top-5">
          <v-row class="mt-4">
            <v-col class="v-col-12 text-center">
              <span class="text-color-0 cursor-pointer" @click="openLogin()">Faça login ou crie seu cadastro para acessar essa página.</span>
            </v-col>
          </v-row>
        </div>
      </v-col>
      <v-col class="v-col-12 v-col-lg-9 px-6 px-lg-0" v-else>
        <div class="w-100 bg-white pa-5 br-top-5" style="height: 100%">
          <v-breadcrumbs class="pa-0">
            <v-breadcrumbs-item class="text-color-0">Home</v-breadcrumbs-item>
            <v-breadcrumbs-divider><v-icon icon="mdi-chevron-right text-color-1"></v-icon></v-breadcrumbs-divider>
            <v-breadcrumbs-item class="text-color-0">Perfil</v-breadcrumbs-item>
            <v-breadcrumbs-divider><v-icon icon="mdi-chevron-right text-color-1"></v-icon></v-breadcrumbs-divider>
          </v-breadcrumbs>
          <h1 class="text-color-0 mt-2">{{ titulo }}</h1>
          <v-form ref="cadastro" lazy-validation v-if="link == 'cadastro'">
            <v-row class="mt-4">
              <v-col class="v-col-12 v-col-lg-6">
                <v-text-field variant="outlined" label="CPF" v-model="dados.cpfcnpj" v-maska:[masks.cpf] disabled></v-text-field>
              </v-col>
              <v-col class="v-col-12 v-col-lg-6">
                <v-text-field variant="outlined" label="E-mail" v-model="dados.email" :rules="[rules.required, rules.email]"></v-text-field>
              </v-col>
              <v-col class="v-col-12">
                <v-text-field variant="outlined" label="Nome e Sobrenome" v-model="dados.name" :rules="[rules.required, rules.minName]"></v-text-field>
              </v-col>
              <v-col class="v-col-12 v-col-lg-6">
                <v-text-field variant="outlined" label="Telefone" v-model="dados.cell" v-maska:[masks.phone] :rules="[rules.required]"></v-text-field>
              </v-col>
              <v-col v-if="dados.cpfcnpj.length <= 14" class="v-col-12 v-col-lg-6">
                <v-select v-model="dados.gender" :items="genders" label="Gênero" item-title="descricao" item-value="id"></v-select>
              </v-col>
              <v-col class="v-col-12 v-col-lg-6">
                <v-text-field variant="outlined" label="Data de Nascimento" v-model="dados.birth_date" v-maska:[masks.date] disabled></v-text-field>
              </v-col>
              <v-col class="v-col-12">
                <v-btn variant="flat" block size="x-large" class="bg-color-2 text-color-white" @click="alterarDados()">ATUALIZAR</v-btn>
              </v-col>
            </v-row>
          </v-form>
          <v-row class="mt-4" v-if="link == 'pedidos'">
            <v-col class="v-col-12 pa-0 pa-lg-2 text-center mb-6">
              <v-skeleton-loader :loading="loadingOrders" type="image" width="100%" height="70px" class="with-margin justify-center">
                <v-table class="w-100" v-if="paginacao > 0 && getOrders.length > 0">
                  <thead>
                    <tr class="bg-color-2">
                      <th class="text-center text-medium text-color-white">Pedido</th>
                      <th class="text-center text-medium text-color-white">Data</th>
                      <th class="text-center text-medium text-color-white">Loja</th>
                      <th class="text-center text-medium text-color-white">Valor</th>
                      <th class="text-center text-medium text-color-white">Status</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="p in getOrders" :key="p.id" class="text-color-0">
                      <td class="text-center">{{ p.order_id }}</td>
                      <td class="text-center">{{ $formatDate(p.finish_date) }} {{ $formatTime(p.finish_date).replace(":", "h") }}</td>
                      <td class="text-center">{{ p.store_name }}</td>
                      <td class="text-center">{{ $formatNumber(p.order_value, {style: 'currency', currency: 'BRL'}) }}</td>
                      <td class="text-center text-no-wrap">{{ p.status }}</td>
                      <td class="d-flex align-center justify-end">
                        <v-btn variant="outlined" class="text-color-2" @click="visualizarPedido(p.order_id)">Visualizar Pedido</v-btn>
                      </td>
                    </tr>
                  </tbody>
                </v-table>
                <p class="text-center" v-else>
                  <b class="text-uppercase text-color-1">Sem Pedidos</b><br>
                  <span class="text-color-0">Você ainda não realizou nenhum pedido.</span>
                </p>
              </v-skeleton-loader>
            </v-col>
          </v-row>
          <v-row class="mt-4" v-if="link == 'enderecos'">
            <v-col class="v-col-12 text-center text-color-2">
              <b class="cursor-pointer" @click="newAddress()">[ + ] Adicionar novo endereço de entrega</b>
            </v-col>
            <v-col class="v-col-12">
              <v-skeleton-loader :loading="loadingAddresses" type="image" width="100%" height="70px" class="with-margin">
                <div class="w-100 border rounded pt-2">
                  <v-card variant="tonal" class="mx-2 mb-2 cursor-pointer" @click="editAddress(e)" :color="e.is_main_address == true ? 'var(--color-one)': '#aaa'" v-for="e in getAlladdresses" :key="e.address_id">
                    <v-card-text class="text-color-0">
                      <v-row>
                        <v-col class="v-col-9 text-left">
                          <b v-if="e.address_nickname != ''">{{ e.address_nickname }}</b><b class="text-color-1 ms-2" v-if="e.is_main_address == true">(Endereço Principal)</b><br>
                          {{ e.street }}, {{ e.num }}<br>
                          {{ e.district }} - {{ e.city }} - {{ e.state }}<br>
                          <b>CEP:</b> {{ e.zip_code }}<br>
                          <b v-if="e.complement != ''">Complemento:</b> {{ e.complement }}
                        </v-col>
                        <v-col class="v-col-3 d-flex align-center justify-end flex-wrap">
                          <v-btn flat :color="'var(--color-one)'" icon="mdi-pencil-outline" class="text-color-white"></v-btn>
                          <v-btn flat :color="'var(--color-red)'" icon="mdi-trash-can-outline" class="text-color-white ms-2 mt-2 mt-md-0" @click.stop="removeAddress(e.address_id)"></v-btn>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </div>
              </v-skeleton-loader>
            </v-col>
          </v-row>
          <v-form ref="senha" lazy-validation v-if="link == 'senha'">
            <v-row class="mt-4">
              <v-col class="v-col-12 v-col-lg-6">
                <v-text-field variant="outlined" label="Digite a senha atual" v-model="password.atual" :rules="[rules.required]" :type="showPasswordAtual ? 'text' : 'password'" :append-inner-icon="showPasswordAtual ? 'mdi-eye' : 'mdi-eye-off'" @click:appendInner="showPasswordAtual = !showPasswordAtual"></v-text-field>
              </v-col>
              <v-col class="v-col-12 v-col-lg-6">
                <v-text-field variant="outlined" label="Digite a senha nova" v-model="password.nova" :rules="[rules.required]" :type="showPasswordNova ? 'text' : 'password'" :append-inner-icon="showPasswordNova ? 'mdi-eye' : 'mdi-eye-off'" @click:appendInner="showPasswordNova = !showPasswordNova"></v-text-field>
              </v-col>
              <v-col class="v-col-12">
                <v-btn variant="flat" block size="x-large" class="bg-color-2 text-color-white" @click="alterarSenha()">ATUALIZAR</v-btn>
              </v-col>
            </v-row>
          </v-form>
          <v-row class="mt-4" v-if="link == 'excluir'">
            <v-col class="v-col-12 text-color-0">
              <p>A exclusão da sua conta na loja virtual <b>VR Connect</b> afeta todos os dados associados a ele e todos os serviços que você usa, como:</p>
              <p>Ofertas, listas de compras, produtos favoritos, pesquisas, prêmios e brindes, pontos nos programas de pontos, entre outros serviços.</p>
              <p>Você pode excluir sua conta na loja virtual <b>VR Connect</b> a qualquer momento, mas não conseguirá restaurá-la.</p>
            </v-col>
            <v-col class="v-col-12">
              <v-btn variant="flat" block size="x-large" class="bg-color-red text-color-white" @click="excluir()">EXCLUIR</v-btn>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
  </v-container>
  <DialogOrder :fechar="fechar" :model="modelOrder" :id="selectedId"></DialogOrder>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import Svgs from '@/components/Svgs.vue';
import DialogOrder from '@/components/DialogOrder.vue';
export default {
  name: "Perfil",
  components: {
    Svgs,
    DialogOrder
  },
  data() {
    return {
      modelOrder: false,
      selectedId: null,
      selectedAddress: null,
      showPasswordAtual: false,
      showPasswordNova: false,
      link: '',
      titulo: '',
      password: {
        atual: '',
        nova: ''
      },
      dados_originais: {
        email: "",
        gender: null,
        cell: "",
      },
      dados: {
        name: "",
        cpfcnpj: "",
        email: "",
        gender: null,
        cell: "",
        birth_date: ""
      },
      masks: {
        cpf: {
          mask: (value) => value.length >= 14 ? '**.***.***/####-##' : "***.***.**#-##",
        },
        phone: {
          mask: "(##) #####-####",
        },
        date: {
          mask: "##/##/####",
        },
      },
      rules: {
        required: v => !!v || 'Este campo é obrigatório.',
        minPhone: v => (v && v.length >= 15) || 'Este campo deve conter no mínimo 15 caracteres.',
        minName: v => (v && v.length >= 3) || 'Este campo deve conter no mínimo 3 caracteres.',
        email: value => {
          return String(value).toLowerCase().match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/) || 'O e-mail informado não é válido.'
        },
      },
      paginacao: 0,
      isLoading: false,
      loadingItens: true,
    }
  },
  computed: {
    ...mapState('main', {
      genders: 'genders'
    }),
    ...mapGetters('main', {
      getConfig: 'getConfig'
    }),
    ...mapGetters('user', {
      getUserInfo: 'getUserInfo',
      getAlladdresses: 'getAlladdresses',
    }),
    ...mapGetters('order', {
      getOrders: 'getOrders'
    }),
    ...mapState('order', {
      loadingOrders: 'loadingOrders'
    }),
    ...mapState('order', {
      loadingAddresses: 'loadingAddresses'
    }),
  },
  methods: {
    ...mapActions('main', {
      setConfig: 'setConfig'
    }),
    ...mapActions('user', {
      logout: 'logout',
      updateUser: 'updateUser',
      updatePassword: 'updatePassword',
      deleteUser: 'deleteUser',
      deleteAddress: 'deleteAddress',
      loadAddresses: 'loadAddresses',
      userProfile: 'userProfile'
    }),
    ...mapActions('order', {
      loadOrders: 'loadOrders'
    }),
    fechar: function(){
      this.modelOrder = false;
      this.selectedId = null;
    },
    scroll(){
      window.addEventListener('scroll', this.checkscroll);
    },
    checkscroll: function() {
      let bottomOfWindow = (document.documentElement.scrollTop + window.innerHeight) > (document.documentElement.offsetHeight - 2400);
      if (bottomOfWindow && document.documentElement.scrollTop > 0) {
        this.loadData();
      }
    },
    loadData(){
      if(this.loadingItens && !this.isLoading){
        this.isLoading = true;
        this.loadOrders(this.paginacao).then(function(response){
          this.isLoading = false;
          if(!response){
            this.loadingItens = false;
          }
          this.paginacao += 1;
        }.bind(this));
      }
    },
    Nav(){
      this.link = this.$route['params']['menu'];
      switch(this.link){
        case "cadastro": 
          this.userProfile().then(function(){
            this.dados.name = this.getUserInfo.name;
            this.dados.cpfcnpj = this.getUserInfo.user_cpfcnpj;
            this.dados.gender = this.getUserInfo.gender;
            this.dados.email = this.getUserInfo.email;
            this.dados.cell = this.getUserInfo.cell;
            this.dados.birth_date = this.$formatDate(this.getUserInfo.birth_date);
            this.dados_originais.name = this.getUserInfo.name;
            this.dados_originais.gender = this.getUserInfo.gender;
            this.dados_originais.email = this.getUserInfo.email;
            this.dados_originais.cell = this.getUserInfo.cell;
          }.bind(this));
          this.titulo = "Meu Cadastro";
        break;
        case "pedidos": 
          this.titulo = "Meus Pedidos"; 
          this.scroll();
          this.loadData();
        break;
        case "enderecos": 
          this.loadAddresses(true);
          this.titulo = "Meus Endereços"; 
        break;
        case "senha": this.titulo = "Alterar Senha"; break;
        case "excluir": this.titulo = "Excluir Conta"; break;
      }
    },
    visualizarPedido(id){
      this.selectedId = id;
      this.modelOrder = true;
    },
    async alterarSenha(){
      const { valid } = await this.$refs.senha.validate();
      if (valid){
        this.updatePassword({ old_password: this.password.atual, new_password: this.password.nova }).then(function(response){
          this.password.atual = null;
          this.password.nova = null;
          this.emitter.emit('dialogMessage', { title: response.cod == 200? "Sucesso!":"Ops!", message: response.msg});
        }.bind(this));
      } 
    },
    removemask(value){
      return value.replaceAll(".", "").replaceAll(" ", "").replaceAll("(", "").replaceAll(")", "").replaceAll("-", "").replaceAll("/", "");
    },
    async alterarDados(){
      const { valid } = await this.$refs.cadastro.validate();
      if (valid){
        let parameters = {};
        if(this.dados_originais.email != this.dados.email)
          parameters.email = this.dados.email;
        
        if(this.dados_originais.gender != this.dados.gender)
          parameters.gender = this.dados.gender;
        
        if(this.removemask(this.dados_originais.cell) != this.removemask(this.dados.cell))
          parameters.phone = this.removemask(this.dados.cell);

        if(this.dados_originais.name != this.dados.name)
          parameters.name = this.dados.name;

        if(parameters.email != undefined || parameters.gender != undefined || parameters.phone != undefined || parameters.name != undefined){
          this.updateUser(parameters).then(function(response){
            this.dados_originais.gender = this.dados.gender;
            this.dados_originais.email = this.dados.email;
            this.dados_originais.cell = this.dados.cell;
            this.dados_originais.name = this.dados.name;
            this.emitter.emit('dialogMessage', { title: response.cod == 200 ? "Sucesso!":"Ops!", message: response.msg});
          }.bind(this));
        } else {
          this.emitter.emit('dialogMessage', { title: "Ops!", message: "Por favor, altere alguma informação do formulário antes de atualizar o cadastro." });
        }
      }
    },
    excluir(){
      this.emitter.emit('dialogMessage', { title: "Atenção!", message: "Você tem certeza de que deseja excluir a sua conta?", response: this.excluirAction});
    },
    excluirAction: function(r){
      if(r){
        this.deleteUser().then(function(response){
          this.emitter.emit('dialogMessage', { title: response.cod == 300? "Sucesso!":"Ops!", message: response.msg});
          if(response.cod == 300){
            this.logout().then(() => {
              this.$router.push('/');
            });
          }
        }.bind(this));
      }
    },
    Logout(){
      this.emitter.emit('dialogMessage', { title: "Atenção!", message: "Você tem certeza de que deseja sair?", response: this.logoutAction});
    },
    logoutAction: function(r){
      if(r){
        this.logout().then(() => {
          this.$router.push('/');
        });
      }
    },
    newAddress(){
      this.emitter.emit('dialogAddress', { address: null });
    },
    editAddress(address){
      this.emitter.emit('dialogAddress', { address: address });
    },
    removeAddress(id){
      this.selectedAddress = id;
      this.emitter.emit('dialogMessage', { title: "Atenção!", message: "Você tem certeza de que deseja remover este endereço?", response: this.removeAddressAction});
    },
    removeAddressAction: function(r){
      if(r){
        this.deleteAddress(this.selectedAddress).then(function(response){
          this.emitter.emit('dialogMessage', { title: response.cod == 300? "Sucesso!":"Ops!", message: response.msg});
          this.selectedAddress = null;
        }.bind(this));
      } else {
        this.selectedAddress = null;
      }
    },
    openLogin(){
      this.emitter.emit('dialogLogin');
    },
  },
  mounted(){
    this.setConfig().then(function(retorno){
      if(retorno){
        if(this.getConfig.isu > 0){
          this.Nav();
        } else {
          this.openLogin();
        }
      } else {
        this.emitter.emit('dialogStores');
      }
      this.emitter.emit("sendAnalyticsView", { screen_name: this.$options.name + " - " + this.titulo } );
    }.bind(this))
    .catch(function () {
      this.$router.push("/baixeoapp");
    }.bind(this));
  },
  unmounted(){
    window.removeEventListener('scroll', this.checkscroll);
  }
}
</script>